import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const StickerHandler = {
  name: "StickerHandler",
  getStickerPackage: function (ChatRoomId, StaffID) {
    var stickerPackage_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetStickerPackage",
      type: "post",
      cache: false,
      async: false,
      data: {
        ChatRoomId,
        StaffID
      },
      dataType: "json",
      success: function (data) {
        stickerPackage_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return stickerPackage_;
  },
  sendSticker: function (stickerId, roomId, staffId) {
    var sendStickerResult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/SendSticker",
      type: "post",
      cache: false,
      async: false,
      data: {
        ChatRoomId: roomId,
        StickerId: stickerId,
        StaffID: staffId
      },
      dataType: "json",
      success: function (data) {
        sendStickerResult_ = data.Success;
        if (!sendStickerResult_) {
          alert("發送貼圖失敗，請重新操作一次或聯絡資訊人員。");
        }
      },
      error: function (a, b, c) {
        alert("發送貼圖發生錯誤，請重新操作一次或聯絡資訊人員。");
      }
    });
    return sendStickerResult_;
  },
};



// WEBPACK FOOTER //
// ./src/handler/StickerHandler.js